import { memo, useCallback } from 'react';

import { type BaseFilterCardProps } from '~/components/Filters/FilterCard';
import { PrivateSourcesSelect } from '~/components/Filters/SourceFilter/components/PrivateSourcesSelect';
import { StringArrayFilterCard, type StringArrayFilterCardProps } from '~/components/Filters/StringArrayFilterCard';

type PrivateSourceFilterCardProps = {
  boardId: string | undefined;
  libraryId: string | undefined;
} & BaseFilterCardProps;

export const PrivateSourceFilterCard = memo(({ boardId, libraryId, ...props }: PrivateSourceFilterCardProps) => {
  const renderSourceSelect = useCallback<StringArrayFilterCardProps['StringSelect']>(
    (props) => <PrivateSourcesSelect boardId={boardId} libraryId={libraryId} {...props} />,
    [boardId, libraryId],
  );

  return (
    <StringArrayFilterCard filter="sources" filterCardType="source" StringSelect={renderSourceSelect} {...props} />
  );
});

PrivateSourceFilterCard.displayName = 'PrivateSourceFilterCard';
